/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForJiraDataCenter extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForJiraDataCenter.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForJiraDataCenter>): GovernanceConfigurationBaseForJiraDataCenter {
        let obj = Object.assign(new GovernanceConfigurationBaseForJiraDataCenter(), model);
        GovernanceConfigurationBaseForJiraDataCenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForJiraDataCenter>): GovernanceConfigurationBaseForJiraDataCenter {
        if (!model) return null;
        return GovernanceConfigurationBaseForJiraDataCenter.newInstance(<GovernanceConfigurationBaseForJiraDataCenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForJiraDataCenter) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForJiraDataCenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForJiraDataCenter): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForJiraDataCenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
